export enum deviceEnvironmentId {
  ANDROID = 'android',
  CLOVER = 'clover',
  IOS = 'iOS',
  WEB = 'web'
}
